module.exports = __webpack_public_path__ + "img/management-philosophy-1.e3a52c7a.png";